import { render } from "./ProductUpdateList.vue?vue&type=template&id=15be2812"
import script from "./ProductUpdateList.vue?vue&type=script&lang=js"
export * from "./ProductUpdateList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__